var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item',{attrs:{"to":_vm.item.route,"active-class":"active"}},[(_vm.item.icon)?_c('i',{class:_vm.item.icon}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.item.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }